export const baseUrl = `${process.env.REACT_APP_BACKEND_URL}`;
export const stripePublicKey = `${process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY}`;
